'use client';

import { identifyHubSpotUser } from '@workspace/ui/lib';
import { useEffect } from 'react';
import { useAuthStore } from '@/stores/authStore';

export function HubSpotIdentityBinding() {
  const user = useAuthStore((state) => state.user);
  const email = user?.user?.email ?? null;

  useEffect(() => {
    identifyHubSpotUser(email);
  }, [email]);

  return null;
}
